// Only load script when we're on placements grid page
if ($('#placements-grid').length > 0) {
    const table = document.querySelector('#placements-grid');

    let savedStates       = JSON.parse(localStorage.getItem('states') || '[]');
    let totalCountVisible = !savedStates.includes('total-count');
    let fixedLeftCount    = totalCountVisible ? 2 : 1;

    // Apply highlight styling for matched global or column-specific search terms
    const drawCallback = function () {
        const api = this.api();
        const globalSearch = api.search();

        if (!globalSearch && !api.columns().any(i => api.column(i).search())) {
            return;
        }

        api.columns().every(function (colIdx) {
            const column = api.column(colIdx);
            if (!column.visible()) return;

            const columnSearch    = column.search();
            const searchTerm      = columnSearch || globalSearch;
            const shouldHighlight = !!searchTerm;

            api.rows({ search: 'applied' }).every(function (rowIdx) {
                const td = api.cell(rowIdx, colIdx).node();

                if (td.dataset.originalHtml) {
                    td.innerHTML = td.dataset.originalHtml;
                } else {
                    td.dataset.originalHtml = td.innerHTML;
                }

                // Apply highlight if applicable
                if (shouldHighlight) {
                    highlightText(td, searchTerm);
                }
            });
        });
    };

    // Initialise the placement DataTable
    $('#loading-message').removeClass('d-none');
    let placementsTable = initialisePlacementsTable(fixedLeftCount);

    if (savedStates.length > 0) {
        setCheckboxStates(JSON.stringify(savedStates));
    }

    /**
     * Add column-specific search inputs to the second header row, trigger a table redraw when search value changes
     *
     * @return {void}
     */
    function bindColumnSearchInputs() {
        $('.table thead tr:eq(1) th').each(function (visibleIdx) {
            const input    = $('input', this)[0];
            const colIndex = placementsTable.column(`${visibleIdx}:visible`).index();

            $(input).off('keyup change').on('keyup change', function () {
                if (placementsTable.column(colIndex).search() !== this.value) {
                    placementsTable
                        .column(colIndex)
                        .search(this.value)
                        .draw();
                }
            });
        });
    }

    /**
     * Initialise the placements DataTable with a specified number of fixed columns on the left
     *
     * @param  {number}         fixedLeft
     * @return {DataTables.Api}
     */
    function initialisePlacementsTable(fixedLeft) {
        return $(table).DataTable({
            ajax: {
                url: table.dataset.ajaxUrl,
                dataSrc: 'data',
            },
            columnDefs: [
                {
                    searchable: false,
                    targets: 1,
                },
                {
                    orderSequence: ['desc', 'asc', ''],
                    targets: '_all',
                },
                {
                    targets: '_all',
                    render: function (data, type) {
                        if (data && typeof data === 'object') {
                            // Use plain text for search/sort
                            if (type === 'filter' || type === 'sort') {
                                return data.display.replaceAll(/<[^>]*>/g, '');
                            }

                            // Use HTML for display
                            return data.display;
                        }

                        return data;
                    },
                    createdCell: function (td, cellData) {
                        if (cellData && typeof cellData === 'object') {
                            if (cellData.className) {
                                $(td).addClass(cellData.className);
                            }

                            if (cellData.tooltip) {
                                $(td)
                                    .attr('data-toggle', 'tooltip')
                                    .attr('data-placement', 'bottom')
                                    .attr('title', cellData.tooltip);
                            }
                        }
                    },
                },
            ],
            deferRender: true,
            drawCallback: drawCallback,
            fixedColumns: {
                left: fixedLeft,
            },
            fixedHeader: true,
            initComplete: function () {
                bindColumnSearchInputs();
                syncHorizontalScroll();
                $('#loading-message').addClass('d-none');
                $('.placement-grid-wrapper, #scroll-to-top-of-table').removeClass('d-none');
            },
            language: {
                lengthLabels: {
                    '-1': 'Show all',
                },
            },
            lengthMenu: [10, 25, 50, 100, 200, -1],
            orderCellsTop: true,
            pageLength: -1,
            scrollX: true,
            searchDelay: 350,
        });
    }

    function syncHorizontalScroll() {
        $('.dt-scroll-head').off('scroll.horizontalSync')
            .on('scroll.horizontalSync', function () {
                syncScrollBody(this.scrollLeft);
            });

        function updateFloatingHeader() {
            $('.dtfh-floating-limiter').each(function () {
                if (this.dataset.horizontalSyncBound === 'true') {
                    return;
                }

                this.dataset.horizontalSyncBound = 'true';
                this.addEventListener('scroll', function () {
                    syncScrollBody(this.scrollLeft);
                });
            });
        }

        updateFloatingHeader();

        $(window).off('scroll.floatingHeaderSync')
            .on('scroll.floatingHeaderSync', updateFloatingHeader);
    }

    function syncScrollBody(scrollLeft) {
        $('.dt-scroll-body, .dt-scroll-head, .dtfh-floating-limiter').each(function () {
            if (this.scrollLeft !== scrollLeft) {
                this.scrollLeft = scrollLeft;
            }
        });
    }

    /**
     * Highlight the searchTerm within a table cell's HTML content
     *
     * @param  {HTMLElement} tdElement
     * @param  {string}      searchTerm
     * @return {void}
     */
    function highlightText(tdElement, searchTerm) {
        const lowerSearch = searchTerm.toLowerCase();

        const walkAndHighlight = (node) => {
            for (const child of Array.from(node.childNodes)) {
                if (child.nodeType === Node.TEXT_NODE) {
                    const text  = child.nodeValue;
                    const index = text.toLowerCase().indexOf(lowerSearch);
                    if (index !== -1) {
                        const before          = document.createTextNode(text.slice(0, index));
                        const highlight       = document.createElement('span');
                        highlight.className   = 'highlight';
                        highlight.textContent = text.slice(index, index + searchTerm.length);
                        const after           = document.createTextNode(text.slice(index + searchTerm.length));
                        child.replaceWith(before, highlight, after);
                    }
                } else if (child.nodeType === Node.ELEMENT_NODE) {
                    walkAndHighlight(child);
                }
            }
        };

        walkAndHighlight(tdElement);
    }

    // Handle toggle column checkbox changes
    $('.toggle-columns').on('change', function () {
        const $checkbox = $(this);
        const $spinner  = $checkbox.siblings('.column-loading-spinner');

        $spinner.removeClass('d-none');

        // Save current hidden columns to localStorage
        const hidden = $('.toggle-columns')
            .filter((_, el) => !el.checked)
            .map((_, el) => $(el).data('set-column'))
            .get();

        localStorage.setItem('states', JSON.stringify(hidden));

        setTimeout(() => {
            updateVisibilityOfColumns();
            $spinner.addClass('d-none');
        }, 0);
    });

    placementsTable.on('draw', function () {
        initialiseTooltips();
    });

    /**
     * Initialise Bootstrap tooltips
     *
     * @return {void}
     */
    function initialiseTooltips() {
        $('[data-toggle="tooltip"]').tooltip({
            container: 'body',
        });
    }

    /**
     * Update column visibility and reinitialise the DataTable with adjusted fixed columns
     *
     * @return {void}
     */
    function updateVisibilityOfColumns() {
        let totalCountVisible = true;

        $('.toggle-columns').each(function () {
            const columnClass = $(this).data('set-column');
            const isVisible   = $(this).prop('checked');

            if (columnClass === 'total-count') {
                totalCountVisible = isVisible;
            }

            placementsTable
                .columns('th.' + columnClass)
                .visible(isVisible, false);
        });

        placementsTable
            .fixedColumns()
            .start(totalCountVisible ? 2 : 1);

        placementsTable.columns.adjust();

        bindColumnSearchInputs();
        initialiseTooltips();
    }

    /**
     * Set the checkbox states based on stored column visibility data
     *
     * @param  {string} states
     * @return {void}
     */
    function setCheckboxStates(states) {
        states = JSON.parse(states || '[]');

        $('.toggle-columns').each(function () {
            var columnClass = $(this).data('set-column');

            var isChecked = !states.includes(columnClass);
            $(this).prop('checked', isChecked);

            // Set visibility on all matching columns
            const columns = placementsTable.columns('th.' + columnClass);
            columns.visible(isChecked, false);
        });

        placementsTable.columns.adjust();
        localStorage.setItem('states', JSON.stringify(states));
    }
}
